module.exports = __webpack_public_path__ + "img/logo.153e30c6.png";